"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("b-modal", {
    staticClass: "modal-new-equipment",
    attrs: {
      active: true,
      width: 598,
      scroll: "keep",
      "can-cancel": ["escape"],
      "on-cancel": _vm.cancelModal
    }
  }, [_c("div", {
    staticClass: "card"
  }, [_c("div", {
    staticClass: "card-content"
  }, [_c("div", {
    staticClass: "media"
  }, [_c("div", {
    staticClass: "media-content"
  }, [_c("button", {
    staticClass: "btn-x-close",
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.cancelModal
    }
  }, [_c("i", {
    staticClass: "icon-ic_close"
  })]), _vm._v(" "), _c("p", {
    staticClass: "title"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")])])]), _vm._v(" "), _c("div", {
    staticClass: "content"
  }, [_c("form", [_c("b-field", {
    attrs: {
      label: "Nome do equipamento"
    }
  }, [_c("b-input", {
    attrs: {
      placeholder: "Nome",
      required: ""
    },
    model: {
      value: _vm.form.nome,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "nome", $$v);
      },
      expression: "form.nome"
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Fabricante"
    }
  }, [_c("b-input", {
    attrs: {
      placeholder: "Fabricante",
      required: ""
    },
    model: {
      value: _vm.form.fabricante,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fabricante", $$v);
      },
      expression: "form.fabricante"
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Tipo"
    }
  }, [_c("b-select", {
    attrs: {
      placeholder: "Selecione um tipo",
      required: "",
      expanded: ""
    },
    model: {
      value: _vm.form.tipo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tipo", $$v);
      },
      expression: "form.tipo"
    }
  }, [_c("option", {
    attrs: {
      value: ""
    }
  }, [_vm._v("\n                Selecionar\n              ")]), _vm._v(" "), _vm._l(_vm.tipos, function (tipo) {
    return _c("option", {
      key: tipo,
      domProps: {
        value: tipo
      }
    }, [_vm._v("\n                " + _vm._s(tipo) + "\n              ")]);
  })], 2)], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Observação (opcional)"
    }
  }, [_c("b-input", {
    attrs: {
      type: "textarea",
      placeholder: "Descreva detalhes sobre o equipamento",
      rows: "3"
    },
    model: {
      value: _vm.form.observacao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "observacao", $$v);
      },
      expression: "form.observacao"
    }
  })], 1), _vm._v(" "), _c("b-field", {
    staticClass: "row-save-form"
  }, [_c("b-button", {
    staticClass: "btn-save-form",
    on: {
      click: _vm.save
    }
  }, [_vm._v("\n              " + _vm._s(_vm.isEdit ? "Gravar" : "Criar") + "\n            ")])], 1)], 1)])])])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;